import React from 'react'
import { components, OptionProps } from 'react-select'
import { isInactiveAccountStatus } from './TotalUsers/AccountStatusFilter'

export type InactiveSelectOption = {
  label: string
  value: string
  isInactive?: boolean
}

const inactiveTagStyle: React.CSSProperties = {
  marginLeft: 8,
  fontSize: 9,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'rgba(236, 94, 123, 1)',
  background: 'rgba(255, 242, 242, 1)',
  padding: '2px 8px',
  borderRadius: 4,
  lineHeight: '100%',
  width: '41px',
  height: '18px',
  flexShrink: 0,
}

export const InactiveTagOption = (props: OptionProps<InactiveSelectOption, false>): JSX.Element => {
  const { data } = props

  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflow: 'hidden', flex: 1 }}>
          {props.label}
        </span>
        {data?.isInactive ? <span style={inactiveTagStyle}>Inactive</span> : null}
      </div>
    </components.Option>
  )
}

export const mapManagerSelectOptions = (managers: { id: number, name: string, userStatus?: string }[]): InactiveSelectOption[] => [
  { label: 'All Managers', value: '', isInactive: false },
  ...managers.map(manager => ({
    label: manager.name,
    value: String(manager.id),
    isInactive: isInactiveAccountStatus(manager.userStatus),
  })),
]
